const whatsappUrl = "https://wa.me/11937354692?text=Ol%C3%A1%2C%20tenho%20interesse%20em%20saber%20mais%20sobre%20o%20financiamento%20para%20minha%20reforma";

export default function Financiamento() {
  return (
    <section id="financiamento" className="py-12 md:py-16 bg-[#F9F6F0]">
      <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">

        {/* Label */}
        <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">
          Crédito para Reforma
        </span>

        {/* Title */}
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-900 mb-3 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Facilitamos o acesso ao crédito para transformar seu ambiente
        </h2>

        {/* Divider */}
        <div className="w-12 h-0.5 bg-amber-600 mx-auto mb-5" />

        {/* Description */}
        <p className="text-stone-500 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto">
          A Vynora acompanha você com orientação e suporte na obtenção de crédito junto a instituições financeiras, tornando sua reforma possível de forma segura e acessível.
        </p>

        {/* Small benefits row */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8">
          {[
            { icon: "ri-file-list-line", text: "Acompanhamento completo" },
            { icon: "ri-folders-line", text: "Orientação documental" },
            { icon: "ri-customer-service-line", text: "Atendimento personalizado" },
          ].map((b) => (
            <div key={b.text} className="flex items-center gap-1.5 text-stone-600 text-xs">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-amber-700 text-xs`} />
              </div>
              <span>{b.text}</span>
            </div>
          ))}
        </div>

        {/* CTA button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-white text-sm font-medium px-7 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-sm" />
          Fale conosco e saiba mais
        </a>

        {/* Trust note */}
        <p className="text-stone-400 text-xs mt-5 max-w-sm mx-auto leading-relaxed">
          A Vynora presta suporte na organização de documentação. Não representamos instituições financeiras.
        </p>

      </div>
    </section>
  );
}
